var exports = {
  "i": "xaee3c4fa--1bae53--wrapper",
};

module.exports = exports;
